import { graphql, useFragment, usePaginationFragment } from "react-relay";

import { AHSeparator, ListItem } from "arkh";

import { memo, useCallback, useMemo } from "react";
import { TeamScheduleStatusRow } from "./TeamScheduleStatusRow";
import { useListContentStyle } from "../../components/mobile/useListContentStyle";
import { FlatList } from "react-native";
import { TeamScheduleHistoryMasterList_team$key } from "./__generated__/TeamScheduleHistoryMasterList_team.graphql";
import { TeamScheduleHistoryMasterListItem_teamSchedule$key } from "./__generated__/TeamScheduleHistoryMasterListItem_teamSchedule.graphql";

export function TeamScheduleHistoryMasterList(props: {
  team: TeamScheduleHistoryMasterList_team$key;
  onSelect(id: string): void;
  currentId: string | null;
}) {
  const { data, loadNext } = usePaginationFragment(
    graphql`
      fragment TeamScheduleHistoryMasterList_team on Team
      @refetchable(queryName: "TeamScheduleHistoryScreen_teamRefetch") {
        teamSchedules(freq: $freq, first: $first, after: $after)
          @connection(key: "TeamScheduleHistoryScreen__teamSchedules") {
          edges {
            node {
              id

              ...TeamScheduleHistoryMasterListItem_teamSchedule
            }
          }
        }
      }
    `,
    props.team
  );

  const listData = useMemo(
    () => data.teamSchedules.edges ?? [],
    [data.teamSchedules.edges]
  );
  const style = useListContentStyle();

  const { onSelect } = props;

  const onPress = useCallback(
    (newId: string) => {
      onSelect(newId);
    },
    [onSelect]
  );

  return (
    <FlatList
      data={listData}
      onEndReached={() => {
        loadNext(10);
      }}
      contentContainerStyle={style}
      ItemSeparatorComponent={AHSeparator}
      renderItem={({ item, index }) => {
        return (
          <TeamScheduleDailyMasterListItem
            isFirst={index === 0}
            isLast={index === listData.length - 1}
            active={props.currentId === item.node.id}
            onPress={onPress}
            teamSchedule={item.node}
          />
        );
      }}
    />
  );
}

const TeamScheduleDailyMasterListItem = memo(TeamScheduleDailyMasterListItemC);
function TeamScheduleDailyMasterListItemC(props: {
  teamSchedule: TeamScheduleHistoryMasterListItem_teamSchedule$key;
  onPress(id: string): void;
  active: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}) {
  const teamSchedule = useFragment(
    graphql`
      fragment TeamScheduleHistoryMasterListItem_teamSchedule on TeamSchedule {
        id
        label
        events(includeInlineRoutines: true) {
          ...TeamScheduleStatusRow_teamScheduleEventOccasion
        }
      }
    `,
    props.teamSchedule
  );

  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      isSelected={props.active}
      onPress={() => {
        props.onPress(teamSchedule.id);
      }}
    >
      <ListItem.Title>{teamSchedule.label}</ListItem.Title>
      <TeamScheduleStatusRow teamSchedule={teamSchedule.events} />
    </ListItem>
  );
}
